export const getProcessEnvironmentValue = (key: string) => {
  if (typeof window === 'undefined') {
    return process.env[key] as string; // process.env always returns strings
  }
  return window[key as any];
};

export default getProcessEnvironmentValue;
